import React from 'react'
import { CircularProgress, Typography } from '@mui/material'

function LoadingSpinnerWithText({
    textToDisplay = "", 
    marginTop = "0px"
}) {
    return (
        <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: marginTop
            }}
        >
            <CircularProgress size="1.8rem" style={{marginBottom:"10px"}}/>
            <Typography variant="body2" color="primary">{textToDisplay}</Typography>
        </div>
    );
}

export default LoadingSpinnerWithText